import axios from "axios";

export default function submitData() {
  var selectedCountry = document.getElementsByClassName("selected");
  var name = document.getElementById("usernameInput").value;
  var phone_number = document.getElementById("phone_number").value;
  var email = document.getElementById("emailInput").value;
  console.log(selectedCountry);
  var list = [];

  function getCountries() {
    for (var i = 0; i < selectedCountry.length; i++) {
      console.log(selectedCountry[i].parentElement.id);
      console.log(selectedCountry[i].children[0].children[1].innerHTML);
      var object = {
        id: selectedCountry[i].parentElement.id,
        country: selectedCountry[i].children[0].children[1].innerHTML,
      };
      list.push(object);
    }
  }

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  function postData(data) {
    axios
      .post("https://bkcountdown.com/nodeapp/addSemiFinalsRecord", data)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function sendEmail(email, data) {
    axios
      .post(
        "https://bkcountdown.com/nodeapp/sendEmailSemi_VN",
        {},
        {
          params: {
            email: email,
            W57: data.W57,
            W58: data.W58,
            W59: data.W59,
            W60: data.W60,
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function updateSemiRecord_name(name, data) {
    axios
      .put(
        "https://bkcountdown.com/nodeapp/updateSemiRecord_name",
        {},
        {
          params: {
            name: name,
            W57: data.W57,
            W58: data.W58,
            W59: data.W59,
            W60: data.W60,
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function updateSemiRecord_phone(phone_number, data) {
    axios
      .put(
        "https://bkcountdown.com/nodeapp/updateSemiRecord_phone",
        {},
        {
          params: {
            phone_number: phone_number,
            W57: data.W57,
            W58: data.W58,
            W59: data.W59,
            W60: data.W60,
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function checkRecord_name(name, email, data) {
    axios
      .get("https://bkcountdown.com/nodeapp/checkRecord_name", {
        params: { name: name },
      })
      .then((res) => {
        if (res.data.length > 0) {
          updateSemiRecord_name(name, data);
          sendEmail(email, data);
        } else {
          postData(data);
          sendEmail(email, data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function checkRecord_phone(phone_number, email, data) {
    axios
      .get("https://bkcountdown.com/nodeapp/checkRecord_phone", {
        params: { phone_number: phone_number },
      })
      .then((res) => {
        if (res.data.length > 0) {
          updateSemiRecord_phone(phone_number, data);
          sendEmail(email, data);
        } else {
          postData(data);
          sendEmail(email, data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //Submission with different conditions.
  if (selectedCountry.length < 4) {
    document.getElementById("modal_body").innerHTML =
      "Vui lòng điền tất cả dự đoán";
  } else if (name !== "" && phone_number !== "") {
    document.getElementById("modal_body").innerHTML =
      "Chỉ điền số điện thoại hoặc tên truy cập";
  } else if (name == "" && phone_number == "") {
    document.getElementById("modal_body").innerHTML =
      "Vui lòng điền số điện thoại hoặc tên truy cập";
  } else if (email == "") {
    console.log("email empty");
    document.getElementById("modal_body").innerHTML =
      "Vui lòng điền địa chỉ Email của bạn";
  } else if (isValidEmail(email) !== true) {
    console.log("email format incorrect");
    document.getElementById("modal_body").innerHTML = "Email không hợp lệ";
  } else if (name !== "" && phone_number == "") {
    getCountries();
    var data = {
      name: `${name}`,
      //phone_number: "",
      email: `${email}`,
      region: "VN",
      W57: `${list[0].country}`,
      W58: `${list[1].country}`,
      W59: `${list[2].country}`,
      W60: `${list[3].country}`,
    };
    checkRecord_name(name, email, data);
    document.getElementById("modal_body").innerHTML =
      "Cảm ơn bạn đã tham gia dự đoán!";
  } else if (name == "" && phone_number !== "") {
    console.log("Submit with phone number!");
    getCountries();
    var data = {
      //name: "",
      email: `${email}`,
      region: "VN",
      phone_number: `${phone_number}`,
      W57: `${list[0].country}`,
      W58: `${list[1].country}`,
      W59: `${list[2].country}`,
      W60: `${list[3].country}`,
    };
    checkRecord_phone(phone_number, email, data);
    document.getElementById("modal_body").innerHTML =
      "Cảm ơn bạn đã tham gia dự đoán!";
    window.open("https://www.bk8p.com/register?affid=24189");
  }
}
